import React, { createContext, useState, useEffect, useContext } from "react";
import { Auth } from "aws-amplify";
// import { useNavigate, useLocation } from "react-router-dom";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [currentUser, setCurrentUser] = useState("");
  const [isSwitchUser, setIsSwitchUser] = useState(false);
  const [allowedGroups, setAllowedGroups] = useState([]);
  const [switchName, setSwitchName] = useState("");

  // const navigate = useNavigate();
  // const location = useLocation();

  const groupingMap = {
    onlyUwGroup: [
      "REACT_APP_UW_GROUPS",
      "REACT_APP_RECAL_GROUP",
      "REACT_APP_GET_QUOTE_GROUP",
    ],
    removeUwGroup: ["REACT_APP_UW_GROUPS", "REACT_APP_RECAL_GROUP"],
  };

  const fetchGroupsFromUser = (original_groups, userType, isSwitchUser) => {
    let _groups = [];
    try {
      const _key_to_lookup =
        userType === "uw" ? "onlyUwGroup" : "removeUwGroup";
      const listG = groupingMap[_key_to_lookup].map((g) => process.env[g]);

      for (let group of original_groups) {
        if (userType === "agent" && !listG.includes(group)) _groups.push(group); //Agent flow
        if (userType === "uw" && listG.includes(group)) _groups.push(group); //UW flow
      }
      if (isSwitchUser && !_groups.includes(switchName))
        _groups.push(switchName);
    } catch (error) {
      console.log(error);
    }
    return _groups;
  };

  useEffect(() => {
    if (isSwitchUser) {
      sessionStorage.setItem("isSwitchUser", "true");
      sessionStorage.setItem("currentUser", currentUser);
      // sessionStorage.setItem("allowedGroups", JSON.stringify(allowedGroups));
    }
  }, [isSwitchUser]);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const sessionSwitch = sessionStorage.getItem("isSwitchUser");
        const sessionCurrentUser = sessionStorage.getItem("currentUser");

        const authUser = await Auth.currentAuthenticatedUser();

        const groups =
          authUser?.signInUserSession?.accessToken?.payload?.[
            "cognito:groups"
          ] || [];

        let isSUser = false;

        for (let group of groups) {
          if (group.includes("SwitchUser")) {
            isSUser = true;
            setSwitchName(group);
            break;
          }
        }
        // const initialGroups = isSUser ? fetchGroupsFromUser(groups, "uw") : groups;
        const _user_type =
          sessionSwitch === "true"
            ? sessionCurrentUser
            : isSUser || groups.includes(process.env.REACT_APP_UW_GROUPS)
            ? "uw"
            : "agent";

        let groups_fetched = fetchGroupsFromUser(
          authUser?.signInUserSession?.accessToken?.payload?.["cognito:groups"] ||
            [],
          _user_type,
          isSwitchUser
        );

        setAllowedGroups(groups_fetched);
        setIsSwitchUser(isSUser);
        setCurrentUser(_user_type);
        setUser(authUser);
      } catch (error) {
        console.error("Error fetching user:", error);
        setUser(null);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUser();
  }, []);

  const toggleSwitchUser = () => {
    const routeTo = currentUser === "uw" ? "/Dashboard" : "/UwPortal";
    const userToBeSaved = currentUser === "uw" ? "agent" : "uw";

    sessionStorage.setItem("isSwitchUser", "true");
    sessionStorage.setItem("currentUser", userToBeSaved);

    setCurrentUser(currentUser === "uw" ? "agent" : "uw");

    window.location.href = routeTo;
  };

  const value = {
    user,
    isLoading,
    isSwitchUser,
    currentUser,
    allowedGroups,
    toggleSwitchUser,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};

export const GlobalAuthContext = AuthContext;
